"use client";

import { Box, Typography, Slider } from "@mui/material";

function AgeRangeFilter({ value, onChange }) {
  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <Box sx={{ px: 1 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 500, color: "black" }}>
          Age Range
        </Typography>
        <Typography variant="body2" color="black">
          {value[0]} - {value[1]} years
        </Typography>
      </Box>

      <Slider
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        min={18}
        max={60}
        step={1}
        sx={{ mb: 1, color: "black" }}
      />

      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="caption" color="black">
          18
        </Typography>
        <Typography variant="caption" color="black">
          60
        </Typography>
      </Box>
    </Box>
  );
}

export default AgeRangeFilter;
